import { Org } from '../pages/Login/loginSlice';
import { useAppSelector } from '../store';

export const useUserOrg = () => {
  const currentUser = useAppSelector((state) => state.login.currentUser);
  const isAPA = currentUser?.organization_id === Org.APA;
  const isOnTrak = currentUser?.organization_id === Org.ONTRAK;
  const isOSI = currentUser?.organization_id === Org.OSI;

  return { isAPA, isOnTrak, isOSI };
};
